import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { trackPageView } from '../utils/usageTracker';
import { MainContentLayout } from '../components/layouts/MainContentLayout';
import { GenericErrorState } from '../components/GenericErrorState';
import { QuotesTable } from '../components/Quotes/QuotesTable';
import { useQuotesData } from '../hooks/useQuotesData';
import { jsx as _jsx } from "react/jsx-runtime";
export const QuotesPage = () => {
  const {
    loading,
    error,
    data: quotes
  } = useQuotesData();
  useEffect(() => {
    trackPageView('quotes-overview');
  }, []);
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "QUOTES_OVERVIEW_LOAD",
      children: /*#__PURE__*/_jsx(MainContentLayout, {
        children: /*#__PURE__*/_jsx(GenericErrorState, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "QUOTES_OVERVIEW_LOAD",
    children: /*#__PURE__*/_jsx(MainContentLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotes.title"
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "700",
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(QuotesTable, {
          loading: loading,
          quotes: quotes
        })
      })
    })
  });
};